// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"7f62c575","86":"c534600c","237":"c1646ed2","621":"7bcfcd5d","695":"f66443d3","894":"d3e7a34b"}[chunkId] + ".chunk.css";
};